interface ChatMessageBubbleProps {
  author: string;
  text: string | null;
  createdAt: string;
  isOwn: boolean;
}

const timestampFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export function ChatMessageBubble({ author, text, createdAt, isOwn }: ChatMessageBubbleProps) {
  const date = new Date(createdAt);
  const timestamp = Number.isNaN(date.getTime()) ? '—' : timestampFormatter.format(date);
  return <article className={`chat-message${isOwn ? ' is-own' : ''}`}>
    <header><strong>{author}</strong><time dateTime={createdAt}>{timestamp}</time></header>
    <p>{text ?? 'Вложение'}</p>
  </article>;
}
